import React, {useContext, useState} from 'react';
import {MortgageContext} from "../../contexts/MortgageProvider";
import {Alert} from "react-bootstrap";
import {FaAngleDoubleRight, FaStepBackward, FaStepForward} from "react-icons/fa";
import {Link} from "react-router-dom";

function Alerts(props) {
    const context = useContext(MortgageContext)
    const alerts = context.mortgage.progress.filter(item => {
        return item?.alertBody && item.alertBody.length > 0
    })
    const [state, setState] = useState({index: 0})
    const [show, setShow] = useState(true);
    const getLink = (alert) => {
        let split = alert.sectionName.split('-')
        let last = split[split.length - 1]
        let applicant = !isNaN(parseInt(last)) ? last : false;
        let link = ''
        switch (alert.sectionType) {
            case "QUESTIONS":
                link = 'upload'
                break
            case "UPLOAD":
                link = 'upload'
                break
            default:
        }
        if (applicant) {
            link += '-' + applicant
            split.pop()
        }
        link += '/'
        link += split.join('-')
        if (alert?.sectionIndex) {
            link += '/' + alert.sectionIndex
        }
        return <Link to={link} className="btn btn-warning btn-sm py-0 px-2 small mt-2 text-white"> Fix
            It <FaAngleDoubleRight/></Link>
    }
    const goForward = ()=>{
        setState(prev=>{
            let v = (prev.index + 1 > alerts.length - 1) ? 0 : prev.index + 1
            return {...prev, index: v}
        })
    }
    const goBackward = ()=>{
        setState(prev=>{
            let v = prev.index < 1 ? prev.index = alerts.length - 1 : prev.index - 1
            return {...prev, index: v}
        })
    }

    if (!alerts.length) {
        return <></>
    }
    return (
        <>
            <div className="position-relative">
                <Alert key={'alert' + state.index} className="pb-4" show={show} variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>

                        <div className="small">
                            Oh shoot!
                        </div>
                    </Alert.Heading>
                    {alerts[state.index].alertBody.map(item => {
                        return <p key={item} className="mb-0 font-alt">{item}</p>
                    })}
                    {getLink(alerts[state.index])}


                </Alert>
                {(alerts.length > 1) && (
                    <div className="d-flex text-warning justify-content-between position-absolute" style={{bottom:'5px', left:'1rem',right:'1rem'}}>
                        <FaStepBackward onClick={goBackward}/>
                        <FaStepForward onClick={goForward}/>
                    </div>

                )}

            </div>


        </>
    );
}

export default Alerts;